/**
 * Mobile social-proof popup fix.
 *
 * Third-party addons (Sales Pop, Consistent Cart) inject recent-purchase
 * popups with position:fixed; top:0 on mobile, covering the header logo
 * and hamburger menu. Their config option "Bottom" is ignored by the
 * runtime bundles, so we override at the theme layer.
 *
 * Strategy:
 *  1. MutationObserver watches for injected/re-injected popup nodes.
 *  2. Any top-anchored fixed popup on mobile is repositioned to the
 *     bottom via element.style.setProperty with 'important' priority —
 *     beats any stylesheet specificity from addon CSS.
 *  3. Close-button click is captured (capture phase, preventDefault +
 *     stopImmediatePropagation) to block the addon's anchor navigation
 *     and its own click handlers; dismissal persists for the session
 *     via sessionStorage.
 *
 * No dependency on jQuery, Shopify theme internals, or the addon API.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var KEY = 'cc_popup_dismissed';
  var HIDE_CSS_ID = 'cc-popup-hide-style';
  var SELECTORS = [
    '#sales-pop-container',
    '.salespop',
    '#cc-notification-container',
    '.cc-notification-container',
    '#cc-notification-popup',
    '.cc-notification',
    '[id*="sales-pop"]',
    '[id*="salespop"]',
    '[class*="salespop"]',
    '[id*="notification-container"]',
    '[class*="notification-container"]',
    '[class*="social-proof"]',
    '[id*="social-proof"]',
    '[class*="recent-purchase"]',
    '[class*="sales-pop"]'
  ];
  var SELECTOR = SELECTORS.join(',');
  var DISMISS_TARGETS = [
    '.dontallow', '.allow',
    '.cc-notification-close', '.cc-close',
    '[data-action="close"]',
    '[class*="close"]', '[aria-label*="close" i]'
  ];

  function isTopAnchoredFixed(el) {
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    var rect = el.getBoundingClientRect();
    return rect.top < 100;
  }

  function repositionToBottom(el) {
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('bottom', '20px', 'important');
    el.style.setProperty('left', '0', 'important');
    el.style.setProperty('right', '0', 'important');
    el.style.setProperty('width', 'calc(100% - 20px)', 'important');
    el.style.setProperty('max-width', '425px', 'important');
    el.style.setProperty('margin', '0 auto', 'important');
    el.style.setProperty('z-index', '690', 'important');
    el.style.setProperty('transform', 'none', 'important');
  }

  function applyMobileFix() {
    if (!MOBILE_MQ.matches) return;
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-cc-repositioned') === '1') continue;
      if (!isTopAnchoredFixed(el)) continue;
      repositionToBottom(el);
      el.setAttribute('data-cc-repositioned', '1');
    }
  }

  function injectHideStyle() {
    if (document.getElementById(HIDE_CSS_ID)) return;
    var styleEl = document.createElement('style');
    styleEl.id = HIDE_CSS_ID;
    styleEl.appendChild(document.createTextNode(SELECTOR + '{display:none !important;}'));
    document.head.appendChild(styleEl);
  }

  function dismiss() {
    try { sessionStorage.setItem(KEY, 'true'); } catch (storageErr) { /* noop */ }
    injectHideStyle();
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  try {
    if (sessionStorage.getItem(KEY) === 'true') injectHideStyle();
  } catch (storageErr) { /* noop */ }

  function handleCloseClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.closest(SELECTOR)) return;
    for (var i = 0; i < DISMISS_TARGETS.length; i++) {
      if (target.closest(DISMISS_TARGETS[i])) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        dismiss();
        return;
      }
    }
  }

  document.addEventListener('click', handleCloseClick, true);
  document.addEventListener('touchend', handleCloseClick, true);
  document.addEventListener('pointerup', handleCloseClick, true);

  function boot() {
    applyMobileFix();
    var observer = new MutationObserver(function () { applyMobileFix(); });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    if (MOBILE_MQ.addEventListener) {
      MOBILE_MQ.addEventListener('change', applyMobileFix);
    } else {
      MOBILE_MQ.addListener(applyMobileFix);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
